import * as React from 'react';
import { ButtonProps } from 'semantic-ui-react/dist/commonjs/elements/Button';

import { Form } from '../../semantic';

export const Button = (props: ButtonProps) => {
  return <Form.Button primary={true} size="big" fluid={true} {...props} />;
};
